export default __webpack_public_path__ + "static/media/icon_tourmaline.536d12ad.png";